import { Box,
  //  Chip, 
  Typography , Divider, Button } from "@mui/material"
// import React from "react"
// import contacts from "../contacts.json"
// import email from "../email.json"
// import FastForwardIcon from "@mui/icons-material/FastForward"
// import GavelIcon from "@mui/icons-material/Gavel"
// import BalanceIcon from "@mui/icons-material/Balance"
// import axios from "axios"
import { Helmet } from "react-helmet"

const Contact = () => {
  // const tallyHoe = {
  //   tallyMark: "Contact City",
  // }
  // const addTallyMark = async () => {
  //   await axios
  //     .post("https://move-hp-forward.onrender.com/tallies/add-tally", tallyHoe)
  //     .then((res) => {
  //       console.log("Tallying: ", res.data)
  //     })
  //     .catch((err) => console.log(err))
  // }

  return (
    // <Box
    //   sx={{
    //     display: "flex",
    //     flexDirection: "column",
    //     alignContent: "center",
    //     alignItems: "center",
    //     padding: "2rem",
    //     gap: "2rem",
    //   }}
    // >
    //   <Helmet>
    //     <title>Contact HP Council</title>
    //   </Helmet>
    //   <Typography textAlign={"center"}>
    //     <span
    //       style={{ textDecoration: "underline", fontWeight: 900, fontSize: 24 }}
    //     >
    //       Please contact our camp at:
    //     </span>{" "}
    //     <a
    //       href={`mailto:info@amendhp.com`}
    //       style={{ fontWeight: 900, fontSize: 24 }}
    //     >
    //       info@amendhp.com
    //     </a>
    //   </Typography>
    //   <Typography
    //     sx={{
    //       border: "1px solid black",
    //       borderRadius: "15px",
    //       padding: ".75rem",
    //     }}
    //   >
    //     We urge you to make your voices heard by those who hold the most
    //     power—our elected representatives. They are in service to us, having
    //     pledged to serve the public and uphold the community's best interests
    //     with integrity and dedication.
    //   </Typography>

    //   <Box
    //     sx={{
    //       display: "flex",
    //       justifyContent: "start",
    //       gap: { xs: "4rem", md: "3rem" },
    //       flexWrap: "wrap",
    //     }}
    //   >
    //     {contacts.map((contact, index) => (
    //       <a
    //         onClick={() => addTallyMark()}
    //         href={`mailto:${contact.email}?cc=gneukirch@cityhpil.com`}
    //         style={{
    //           textDecoration: "none",
    //           color: index === 0 ? "blue" : "black",
    //         }}
    //       >
    //         <Box
    //           key={index}
    //           sx={
    //             index === 0 && {
    //               border: "3px solid black",
    //               padding: "1rem",
    //               borderRadius: "15px",
    //               "&:hover": {
    //                 backgroundColor: "rgba(0, 0, 0, 0.2)", // Background color on hover
    //               },
    //             }
    //           }
    //         >
    //           {index === 0 && (
    //             <Typography sx={{ fontWeight: 800, fontSize: "1.5rem" }}>
    //               Contact the entire City Council here:
    //             </Typography>
    //           )}
    //           <Box
    //             sx={{ display: "flex", alignItems: "center", gap: ".75rem" }}
    //           >
    //             <Typography>{contact.name}</Typography>{" "}
    //             <Chip
    //               sx={{
    //                 ".MuiChip-icon": { marginLeft: "40%" },
    //               }}
    //               icon={
    //                 contact.stance === "Stagnation" ? (
    //                   <GavelIcon />
    //                 ) : contact.stance === "Middle" ? (
    //                   <BalanceIcon />
    //                 ) : (
    //                   <FastForwardIcon />
    //                 )
    //               }
    //               color={
    //                 contact.stance === "Stagnation"
    //                   ? "error"
    //                   : contact.stance === "Middle"
    //                   ? "warning"
    //                   : "success"
    //               }
    //             />
    //           </Box>
    //           <Typography>{contact.title}</Typography>

    //           <Typography sx={{ textDecoration: "underline" }}>
    //             {contact.email}
    //           </Typography>
    //         </Box>
    //       </a>
    //     ))}
    //   </Box>
    // </Box>
     <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        padding: "2rem",
        gap: "2rem",
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1a1a1a, #2c5364)",
        color: "white",
      }}
    >
      <Helmet>
        <title>Contact Ravinia's Vault</title>
      </Helmet>

      <Typography variant="h3" sx={{ fontWeight: 700, color: "#00e676" }}>
        Contact Us
      </Typography>

      <Divider sx={{ width: "60%", backgroundColor: "#00e676" }} />

      <Typography variant="body1" sx={{ maxWidth: "600px", textAlign: "center", fontSize: "1.1rem" }}>
        Have questions? Want to contribute? Curious how to get involved with Ravinia's VAULT, Give Where You Live, or The Big PAYBACK?  
        We want to hear from you. Drop us a line below or email us directly.
      </Typography>

      <Button
        href="mailto:info@amendhp.com"
        variant="contained"
        sx={{
          backgroundColor: "#00e676",
          color: "#000",
          fontWeight: 600,
          borderRadius: "25px",
          px: 4,
          py: 1.5,
          "&:hover": {
            backgroundColor: "#00c853",
          },
        }}
      >
        Email info@amendhp.com
      </Button>

      <Typography variant="h6" sx={{ mt: 2, color: "#00e676", fontWeight: 700 }}>
        Or call us: <a href="tel:7735583112" style={{ color: "#00c853", textDecoration: "none", fontWeight: 700 }}>773-558-3112</a>
      </Typography>

      <Typography variant="body1" sx={{ mt: 3, maxWidth: "600px", textAlign: "center", fontWeight: 500 }}>
        Want to stay updated and support our movement? Click below to join our mailing list and get the latest news, events, and ways to get involved.
      </Typography>
      <Button
        href="/subscribe"
        variant="contained"
        sx={{
          backgroundColor: "#00e676",
          color: "#000",
          fontWeight: 700,
          borderRadius: "30px",
          px: 5,
          py: 2,
          mt: 1,
          boxShadow: "0 2px 12px rgba(0,0,0,0.18)",
          "&:hover": {
            backgroundColor: "#00c853",
          },
        }}
      >
        Subscribe for Updates
      </Button>

      {/* Optional future form input (not functional yet) */}
      {/* <Container maxWidth="sm">
        <Box component="form" sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField label="Name" variant="filled" fullWidth sx={{ backgroundColor: "white", borderRadius: 1 }} />
          <TextField label="Email" variant="filled" fullWidth sx={{ backgroundColor: "white", borderRadius: 1 }} />
          <TextField
            label="Message"
            variant="filled"
            multiline
            rows={4}
            fullWidth
            sx={{ backgroundColor: "white", borderRadius: 1 }}
          />
          <Button variant="contained" sx={{ mt: 2, backgroundColor: "#00e676", color: "#000" }}>
            Send Message
          </Button>
        </Box>
      </Container> */}
    </Box>
  )
}

export default Contact
